import React, { useState } from 'react';
import ConceptBlueprintModal from '../ConceptBlueprintModal';
import ProposedPagesModal from '../ProposedPagesModal';

const ConceptSection = ({ conceptBlueprint, proposedPages }) => {
    const [isBlueprintModalOpen, setIsBlueprintModalOpen] = useState(false);
    const [isProposedPagesModalOpen, setIsProposedPagesModalOpen] = useState(false);

    const hasConceptData = conceptBlueprint && conceptBlueprint.concept;
    const hasProposedPages = proposedPages && Array.isArray(proposedPages.proposed_pages) && proposedPages.proposed_pages.length > 0;

    if (!hasConceptData && !hasProposedPages) {
        return (
            <div style={{ marginBottom: '30px' }}>
                <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Concept</h4>
                <div style={{
                    background: 'linear-gradient(135deg, rgba(156, 163, 175, 0.18), rgba(156, 163, 175, 0.06))',
                    border: '1px solid rgba(156, 163, 175, 0.35)',
                    borderRadius: '12px',
                    padding: '20px',
                    color: '#a0a0a0',
                    textAlign: 'center'
                }}>
                    No concept data available
                </div>
            </div>
        );
    }

    const cardStyle = {
        background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.18), rgba(139, 92, 246, 0.05))',
        border: '1px solid rgba(139, 92, 246, 0.35)',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    };

    const cardHoverStyle = {
        background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.25), rgba(139, 92, 246, 0.08))',
        border: '1px solid rgba(139, 92, 246, 0.5)',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(139, 92, 246, 0.2)'
    };

    const headingStyle = {
        fontSize: '18px',
        fontWeight: '600',
        color: '#e0e0e0',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    };

    const descriptionStyle = {
        fontSize: '14px',
        color: '#c0c0c0',
        lineHeight: '1.6',
        marginBottom: '12px'
    };

    const badgeStyle = {
        backgroundColor: '#8b5cf6',
        color: '#ffffff',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px'
    };

    const summaryStyle = {
        fontSize: '13px',
        color: '#9a9a9a',
        marginTop: '8px',
        lineHeight: '1.5'
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '20px', color: '#e0e0e0', fontWeight: '600' }}>Concept</h4>
            
            {/* Concept Blueprint Card */}
            {hasConceptData && (
                <div
                    style={cardStyle}
                    onClick={() => setIsBlueprintModalOpen(true)}
                    onMouseEnter={(e) => {
                        Object.assign(e.currentTarget.style, cardHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                        Object.assign(e.currentTarget.style, cardStyle);
                    }}
                >
                    <div style={headingStyle}>
                        <span>Concept Blueprint</span>
                        <span style={badgeStyle}>
                            📋 View Details →
                        </span>
                    </div>
                    {conceptBlueprint.concept.website_overview && (
                        <div style={descriptionStyle}>
                            <strong style={{ color: '#e0e0e0' }}>Overview:</strong>{' '}
                            {conceptBlueprint.concept.website_overview.current_state_summary 
                                ? conceptBlueprint.concept.website_overview.current_state_summary.substring(0, 200) + '...'
                                : 'No overview available'}
                        </div>
                    )}
                    {conceptBlueprint.concept.website_overview?.target_audience && (
                        <div style={summaryStyle}>
                            <strong>Target Audience:</strong> {conceptBlueprint.concept.website_overview.target_audience.substring(0, 150)}...
                        </div>
                    )}
                    {conceptBlueprint.concept.redesign_priorities && (
                        <div style={summaryStyle}>
                            <strong>Critical Improvements:</strong> {conceptBlueprint.concept.redesign_priorities.critical_improvements?.length || 0} items
                        </div>
                    )}
                </div>
            )}

            {/* Proposed Pages Card */}
            {hasProposedPages && (
                <div
                    style={cardStyle}
                    onClick={() => setIsProposedPagesModalOpen(true)}
                    onMouseEnter={(e) => {
                        Object.assign(e.currentTarget.style, cardHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                        Object.assign(e.currentTarget.style, cardStyle);
                    }}
                >
                    <div style={headingStyle}>
                        <span>Proposed Pages</span>
                        <span style={badgeStyle}>
                            📄 {proposedPages.proposed_pages.length} Pages →
                        </span>
                    </div>
                    <div style={descriptionStyle}>
                        Detailed page specifications including purpose, content requirements, SEO, and user experience considerations.
                    </div>
                    {proposedPages.summary && (
                        <div style={summaryStyle}>
                            <strong>Total Pages:</strong> {proposedPages.summary.total_pages || proposedPages.proposed_pages.length} 
                            {' • '}
                            <strong>Critical:</strong> {proposedPages.summary.critical_pages || proposedPages.proposed_pages.filter(p => p.priority === 'critical').length}
                            {' • '}
                            <strong>High Priority:</strong> {proposedPages.summary.high_priority_pages || proposedPages.proposed_pages.filter(p => p.priority === 'high').length}
                        </div>
                    )}
                </div>
            )}

            {/* Modals */}
            {hasConceptData && (
                <ConceptBlueprintModal
                    isOpen={isBlueprintModalOpen}
                    onClose={() => setIsBlueprintModalOpen(false)}
                    conceptBlueprint={conceptBlueprint}
                />
            )}

            {hasProposedPages && (
                <ProposedPagesModal
                    isOpen={isProposedPagesModalOpen}
                    onClose={() => setIsProposedPagesModalOpen(false)}
                    proposedPages={proposedPages}
                />
            )}
        </div>
    );
};

export default ConceptSection;

